module.exports = __webpack_public_path__ + "img/25.f06a7bed.png";